import {
  PERCENTUAL_MAXIMO,
  TAMANHO_MAXIMO_CHAVE_RESTRICAO,
  centavos,
  formatMoney,
  formatPercentual,
  numero,
  positivo,
  tetoDaFaixa,
} from "../helpers";

export const COMBINACOES = [
  {
    campo: "permiteComPromocao",
    titulo: "Permite com promoção?",
    resumo: "Promoção",
    ajuda: "Itens com preço promocional entram na base de cálculo. Desligado, eles são retirados da base.",
  },
  {
    campo: "permiteComCupom",
    titulo: "Permite com cupom?",
    resumo: "Cupom",
    ajuda: "Pedidos com cupom de desconto geram cashback.",
  },
  {
    campo: "permiteComCampanha",
    titulo: "Permite com campanha comercial?",
    resumo: "Campanha comercial",
    ajuda: "Pedidos com desconto ou brinde de campanha comercial geram cashback.",
  },
  {
    campo: "permiteComCredito",
    titulo: "Permite com crédito do cliente?",
    resumo: "Crédito do cliente",
    ajuda: "Pedidos que abatem crédito do cliente geram cashback.",
  },
  {
    campo: "permiteComUsoCashback",
    titulo: "Permite com uso de cashback?",
    resumo: "Uso de cashback",
    ajuda: "Pedidos que usam saldo de cashback também geram cashback novo. Ao ativar, escolha abaixo como o ganho é calculado.",
  },
];

export const GANHOS_COM_USO = [
  {
    chave: "TOTAL",
    titulo: "Ganho integral",
    resumo: "ganho integral, como se o saldo não tivesse sido usado",
    descricao: "Calcula sobre o valor total do pedido, ignorando o saldo usado. Ex.: pedido de R$ 3.000 a 2% usando R$ 50 gera R$ 60.",
  },
  {
    chave: "TOTAL_MENOS_USO",
    titulo: "Ganho sobre o valor pago",
    resumo: "ganho calculado sobre o valor do pedido descontado o cashback usado",
    descricao: "Calcula sobre o pedido descontado o saldo usado. Ex.: pedido de R$ 3.000 a 2% usando R$ 50 gera 2% de R$ 2.950 = R$ 59.",
  },
  {
    chave: "GANHO_MENOS_USO",
    titulo: "Ganho descontado do uso",
    resumo: "o cashback usado é descontado do cashback gerado",
    descricao:
      "O saldo usado é abatido do cashback que o pedido gera. Ex.: pedido de R$ 3.000 a 2% usando R$ 50 gera R$ 60 - R$ 50 = R$ 10. Com mais de uma campanha, o abatimento é proporcional.",
  },
];

export const ganhoComUso = (chave) => GANHOS_COM_USO.find((opcao) => opcao.chave === chave) || GANHOS_COM_USO[0];

const teto = tetoDaFaixa;

export const inicioSeguinte = (faixa) => (centavos(teto(faixa)) + 1) / 100;

export function errosFaixas(faixas) {
  return faixas.map((faixa, indice) => {
    const erros = {};
    const minimo = numero(faixa.valorMinimo);
    const maximo = teto(faixa);
    const anterior = indice > 0 ? faixas[indice - 1] : null;

    if (minimo < 0) {
      erros.valorMinimo = "O valor não pode ser negativo.";
    } else if (anterior && teto(anterior) !== null && centavos(minimo) <= centavos(teto(anterior))) {
      erros.valorMinimo = `Precisa começar depois do "Até" da faixa anterior (${formatMoney(teto(anterior))}).`;
    } else if (anterior && minimo <= numero(anterior.valorMinimo)) {
      erros.valorMinimo = `Precisa ser maior que o "A partir de" da faixa anterior (${formatMoney(anterior.valorMinimo)}).`;
    }

    if (numero(faixa.valorMaximo) < 0) {
      erros.valorMaximo = "O valor não pode ser negativo.";
    } else if (maximo !== null && maximo <= minimo) {
      erros.valorMaximo = `Precisa ser maior que o "A partir de" (${formatMoney(minimo)}).`;
    } else if (maximo === null && indice < faixas.length - 1) {
      erros.valorMaximo = 'Só a última faixa pode ficar sem "Até".';
    }

    if (faixa.percentual === null || faixa.percentual === undefined || faixa.percentual === "" || numero(faixa.percentual) < 0) {
      erros.percentual = "Informe o percentual (0% para faixa sem cashback).";
    } else if (numero(faixa.percentual) > PERCENTUAL_MAXIMO) {
      erros.percentual = "O percentual não pode passar de 100%.";
    }

    return erros;
  });
}

export function avisosFaixas(faixas) {
  return faixas.map((faixa, indice) => {
    const anterior = indice > 0 ? faixas[indice - 1] : null;

    if (faixa.percentual !== null && faixa.percentual !== undefined && faixa.percentual !== "" && numero(faixa.percentual) === 0) {
      return "Faixa sem cashback: pedidos com a base dentro dela não geram cashback.";
    }

    if (anterior && teto(anterior) !== null && centavos(faixa.valorMinimo) > centavos(teto(anterior)) + 1) {
      return `Entre ${formatMoney(inicioSeguinte(anterior))} e ${formatMoney((centavos(faixa.valorMinimo) - 1) / 100)} o pedido não gera cashback.`;
    }

    if (!anterior || !(numero(faixa.percentual) > 0) || numero(faixa.percentual) >= numero(anterior.percentual)) return null;

    return `O retorno é menor que o da faixa anterior (${formatPercentual(anterior.percentual)}): pedidos maiores vão ganhar proporcionalmente menos.`;
  });
}

export function primeiroErroFaixa(faixas) {
  const erros = errosFaixas(faixas);
  const indice = erros.findIndex((erro) => Object.keys(erro).length);

  return indice < 0 ? null : `Faixa ${indice + 1}: ${Object.values(erros[indice])[0]}`;
}

function propagarCascata(originais, faixas, indice) {
  for (let posicao = indice + 1; posicao < faixas.length; posicao += 1) {
    const tetoNovo = centavos(faixas[posicao - 1].valorMaximo);

    if (tetoNovo <= 0) break;

    const tetoAntigo = centavos(originais[posicao - 1].valorMaximo);
    const inicio = centavos(originais[posicao].valorMinimo);
    const colada = tetoAntigo > 0 && inicio === tetoAntigo + 1;
    const sobreposta = inicio <= tetoNovo;

    if (!colada && !sobreposta) break;

    const novoInicio = tetoNovo + 1;
    const tetoOriginal = centavos(originais[posicao].valorMaximo);

    faixas[posicao].valorMinimo = novoInicio / 100;

    if (tetoOriginal <= 0) break;

    faixas[posicao].valorMaximo = (tetoOriginal + novoInicio - inicio) / 100;
  }

  return faixas;
}

export function cascatearFaixas(originais, indice, campo, valor) {
  const faixas = originais.map((faixa) => ({ ...faixa }));
  const faixa = faixas[indice];
  const original = originais[indice];

  faixa[campo] = valor;

  if (campo === "valorMinimo") {
    const tetoOriginal = centavos(original.valorMaximo);

    if (tetoOriginal <= 0) return faixas;

    const minimo = centavos(valor);

    faixa.valorMaximo = (minimo >= tetoOriginal ? tetoOriginal + minimo - centavos(original.valorMinimo) : tetoOriginal) / 100;
  }

  return propagarCascata(originais, faixas, indice);
}

export function faixasAlteradas(antes, depois) {
  return depois.reduce((indices, faixa, indice) => {
    const anterior = antes[indice] || {};

    if (centavos(anterior.valorMinimo) !== centavos(faixa.valorMinimo) || centavos(anterior.valorMaximo) !== centavos(faixa.valorMaximo)) {
      indices.push(indice);
    }

    return indices;
  }, []);
}

export function novaFaixa(faixas) {
  const ultima = faixas[faixas.length - 1];

  return {
    valorMinimo: ultima && teto(ultima) !== null ? inicioSeguinte(ultima) : 0,
    valorMaximo: null,
    percentual: ultima ? Math.min(PERCENTUAL_MAXIMO, numero(ultima.percentual) + 1) : 1,
  };
}

const inteiro = (valor) => valor !== null && valor !== "" && Number.isInteger(Number(valor));

const MESES_MAXIMO_MEDIA_ATRASO = 36;

const temMediaAtraso = (regra) => regra.mediaAtrasoMaximaDias !== null && regra.mediaAtrasoMaximaDias !== undefined && regra.mediaAtrasoMaximaDias !== "";

export const semValidade = (regra) => regra.validadeDias === null || regra.validadeDias === undefined || regra.validadeDias === "" || Number(regra.validadeDias) === 0;

export function validarRegra(regra) {
  if (!String(regra.nome || "").trim()) return { aba: 0, mensagem: "Informe o nome da regra." };

  const prioridade = regra.prioridade === null || regra.prioridade === "" || regra.prioridade === undefined ? 0 : regra.prioridade;

  if (!inteiro(prioridade) || Number(prioridade) < 0) {
    return { aba: 0, mensagem: "A prioridade precisa ser um número inteiro maior ou igual a zero." };
  }

  if (!(regra.canais || []).length) return { aba: 0, mensagem: "Selecione ao menos um canal." };

  if (regra.dataInicio && regra.dataFim && regra.dataFim < regra.dataInicio) {
    return { aba: 0, mensagem: "O fim da vigência não pode ser anterior ao início." };
  }

  const faixas = regra.faixas || [];

  if (!faixas.length) return { aba: 1, mensagem: "Cadastre ao menos uma faixa." };

  const erroFaixa = primeiroErroFaixa(faixas);

  if (erroFaixa) return { aba: 1, mensagem: erroFaixa };

  if (!faixas.some((faixa) => numero(faixa.percentual) > 0)) {
    return { aba: 1, mensagem: "Informe ao menos uma faixa com percentual maior que zero." };
  }

  const restricaoLonga = (regra.restricoes || []).find((restricao) => String(restricao.chave || "").length > TAMANHO_MAXIMO_CHAVE_RESTRICAO);

  if (restricaoLonga) {
    return { aba: 2, mensagem: `O código "${restricaoLonga.chave}" passa de ${TAMANHO_MAXIMO_CHAVE_RESTRICAO} caracteres.` };
  }

  if (!semValidade(regra) && (!inteiro(regra.validadeDias) || Number(regra.validadeDias) < 0)) {
    return { aba: 3, mensagem: "Informe a validade do cashback em dias inteiros, ou deixe vazio para não ter prazo." };
  }

  const mediaAtraso = regra.mediaAtrasoMaximaDias;

  if (mediaAtraso !== null && mediaAtraso !== undefined && mediaAtraso !== "") {
    if (!inteiro(mediaAtraso) || Number(mediaAtraso) < 0) {
      return { aba: 3, mensagem: "Informe a média de atraso máxima em dias inteiros, ou deixe vazio para não verificar." };
    }

    const meses = regra.mediaAtrasoMeses;

    if (meses !== null && meses !== undefined && meses !== "" && (!inteiro(meses) || Number(meses) < 1 || Number(meses) > MESES_MAXIMO_MEDIA_ATRASO)) {
      return { aba: 3, mensagem: `Informe o período da média de atraso entre 1 e ${MESES_MAXIMO_MEDIA_ATRASO} meses.` };
    }
  }

  const tolerancia = regra.toleranciaDiasTituloVencido;

  if (tolerancia !== null && tolerancia !== "" && tolerancia !== undefined && (!inteiro(tolerancia) || Number(tolerancia) < 0)) {
    return { aba: 3, mensagem: "A tolerância de atraso precisa ser um número inteiro de dias." };
  }

  return null;
}

export function rotuloDimensao(label) {
  const texto = String(label || "").toLowerCase();

  return texto.charAt(0).toUpperCase() + texto.slice(1);
}

export function payloadRegra(regra) {
  return {
    nome: regra.nome,
    descricao: regra.descricao || null,
    ativo: !!regra.ativo,
    prioridade: Number(regra.prioridade || 0),
    dataInicio: regra.dataInicio || null,
    dataFim: regra.dataFim || null,
    canais: regra.canais,
    validadeDias: semValidade(regra) ? null : Number(regra.validadeDias),
    exigeSemTituloVencido: !!regra.exigeSemTituloVencido,
    toleranciaDiasTituloVencido: Number(regra.toleranciaDiasTituloVencido || 0),
    mediaAtrasoMaximaDias: temMediaAtraso(regra) ? Number(regra.mediaAtrasoMaximaDias) : null,
    mediaAtrasoMeses: temMediaAtraso(regra) && Number(regra.mediaAtrasoMeses) > 0 ? Number(regra.mediaAtrasoMeses) : null,
    limiteValorPedido: positivo(regra.limiteValorPedido),
    limiteValorCliente: positivo(regra.limiteValorCliente),
    limiteValorTotal: positivo(regra.limiteValorTotal),
    limitePeriodo: regra.limitePeriodo || null,
    mensagemIncentivo: regra.mensagemIncentivo || null,
    permiteComPromocao: !!regra.permiteComPromocao,
    permiteComCupom: !!regra.permiteComCupom,
    permiteComCampanha: !!regra.permiteComCampanha,
    permiteComCredito: !!regra.permiteComCredito,
    permiteComUsoCashback: !!regra.permiteComUsoCashback,
    baseComUso: regra.baseComUso || "TOTAL",
    baseValor: regra.baseValor || "COM_IMPOSTO",
    comportamentoTeto: regra.comportamentoTeto || "SEM_CASHBACK",
    faixas: regra.faixas.map((faixa) => ({
      valorMinimo: Number(faixa.valorMinimo || 0),
      valorMaximo: positivo(faixa.valorMaximo),
      percentual: Number(faixa.percentual),
    })),
    restricoes: regra.restricoes.map((restricao) => ({
      tipo: restricao.tipo,
      chave: String(restricao.chave),
      dimensaoColuna: restricao.dimensaoColuna || null,
    })),
  };
}

export function opcoesComportamentoTeto(faixasOrdenadas) {
  const ultima = faixasOrdenadas[faixasOrdenadas.length - 1];
  const teto = ultima && Number(ultima.valorMaximo) > 0 ? Number(ultima.valorMaximo) : null;

  if (teto === null) return [];

  const percentual = Number(ultima.percentual) || 0;
  const exemplo = Math.round(teto * 1.5 * 100) / 100;
  const ganhoNoTeto = Math.round(teto * percentual) / 100;

  return [
    {
      chave: "SEM_CASHBACK",
      titulo: "Não gera cashback",
      descricao: `O pedido acima do teto não ganha nada. Ex.: um pedido de ${formatMoney(exemplo)} gera ${formatMoney(0)}.`,
    },
    {
      chave: "LIMITA_AO_TETO",
      titulo: "Gera cashback até o teto",
      descricao: `O pedido ganha ${formatPercentual(percentual)} calculados só sobre ${formatMoney(teto)}; o que passar do teto não conta. Ex.: um pedido de ${formatMoney(
        exemplo
      )} gera ${formatMoney(ganhoNoTeto)}.`,
    },
  ];
}
